import { action, observable } from "mobx";
import { observer } from "mobx-react";
import { Button } from "primereact/button";
import React, { useContext, useMemo } from "react";
import { useDropzone } from "react-dropzone";
import { useQueryClient } from "react-query";
import styled from "styled-components";
import { useLocStore } from "../../../../wsLocalization";
import { LocContext } from "../../../../wsLocalization/LocContext";
import { useLatestQuery } from "../../../../WSUtils/useLatestQuery";
import { UserInfoContext } from "../../../../WSUtils/UserInfoContext";
import { useStore2 } from "../../../../WSUtils/useStore";
import { concatClassnames } from "../../../../WSUtils/util";
import { WSFormGrid } from "../../../../WSUtils/WSFormGrid";
import { CVEditContext } from "../../CVEditContext";
import { CVEditInvalidStateReminder } from "../../CVEditInvalidStateReminder";
import { CVEditLanguageSegmentStore } from "../../QualificationsStep/LanguageSegment/CVEditLanguageSegmentStore";
import { CVEditDocumentList } from "./CVEditDocumentList";
import { CVEditDocumentsSegmentStore } from "./CVEditDocumentSegmentStore";

export const CVEditDocumentsSegment = observer(() => {
  const L = useLocStore(LocContext.CV);
  const cvEditContext = useContext(CVEditContext);
  const userInfo = useContext(UserInfoContext);
  const queryClient = useQueryClient();

  const documentsSegmentStore = useStore2(
    "CVEditDocumentsSegmentStore",
    (dt) =>
      new CVEditDocumentsSegmentStore({
        name: "CVEditDocumentsSegmentStore",

        parentDt: dt,
        useHooks: (t: CVEditLanguageSegmentStore) => {
          t.userInfo = useContext(UserInfoContext);
          t.queryClient = useQueryClient();
          t.cvEditContext = useContext(CVEditContext);
        },
      })
  );

  /*  useEffect(() => {
    return when(
      () => !!this.documentsField.store.value,
      () => {
        this.dt.disposers.push(
          autorun(() => {
            this.addingDocument;

            runInAction(() => {
              this.documentEditorStore?.dt?.dispose();
              this.documentEditorStore = null;

              if (this.addingDocument) {
                this.documentEditorStore = new CVEditDocumentEditorStore({
                  name: "CVEditDocumentEditorStore",
                  getUserInfo: this.getUserInfo,
                  getCvEditContext: this.getCvEditContext,
                  parentDt: this.dt,
                  getFile: () => this.file,
                  showEditor: () => this.showEditor,
                  onCloseEditor: () => {},
                });
              }
            });
          })
        );
      }
    );
  });*/

  const { data: documents } = useLatestQuery(
    ["documentsAPI.getDocuments"],
    () =>
      userInfo.fullAPI.documentsAPI.getDocuments({
        userInfo,
      })
  );

  const saving = useMemo(() => observable.box(false), []);

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    open: openDocumentPicker,
  } = useDropzone({
    multiple: false,
    noClick: true,
    onDrop: action((acceptedFiles) => {
      documentsSegmentStore.onFileAccepted(acceptedFiles[0]);
    }),
  });

  return (
    <CVEditDocumentSegmentStyles
      className="cve-document-segment cve-segment"
      {...getRootProps()}
    >
      <div className="cvp-h2 cve-header">
        {L.id("4da4e33a4346").loc("Dokumenter")}
      </div>

      {!documentsSegmentStore.showPlaceholder && (
        <CVEditDocumentList documentsSegmentStore={documentsSegmentStore} />
      )}

      {/*!!documentsSegmentStore.showEditor && (
        <>
          <div className="cve-separator" />
          <CVEditDocumentEditor
            openDocumentPicker={openDocumentPicker}
            docEditorStore={documentsSegmentStore.documentEditorStore}
            headerText={L.id("db942958f3a2").loc("Lagre dokument")}
          />
        </>
      )*/}

      <WSFormGrid
        float
        className={concatClassnames([
          "cve-button-bar",
          documentsSegmentStore.showPlaceholder && "cve-button-bar-placeholder",
        ])}
      >
        <CVEditInvalidStateReminder
          showReminder={() => {
            /*const documentEditorStore =
              documentsSegmentStore.documentEditorStore;

            if (!documentEditorStore) return false;
            return documentEditorStore.visibleValidationErrors.length > 0;*/
            return false;
          }}
        />

        <Button
          icon="pi pi-upload"
          className={concatClassnames([
            "p-button p-button-outlined cve-document-upload-button",
            documentsSegmentStore.showPlaceholder &&
              "cve-empty-list-placeholder cve-empty-document-placeholder",
          ])}
          label={L.id("28fb68459858").loc("Last opp dokument")}
          loading={saving.get()}
          onClick={(evt) => {
            evt.preventDefault();

            if (!documentsSegmentStore.showEditor) {
              openDocumentPicker();
              return false;
            }

            /*const save = flow(function* () {
              saving.set(true);
              try {
                yield saveCurrentlyEditingDocumentAndCloseEditor({
                  userInfo,
                  cvEditContext,
                  queryClient,
                  file: documentsSegmentStore.file,
                  editorStore: documentsSegmentStore.documentEditorStore,
                });
              } finally {
                saving.set(false);
              }
            });

            save();*/

            return false;
          }}
        />
      </WSFormGrid>
      <input {...getInputProps()} />
    </CVEditDocumentSegmentStyles>
  );
});

const CVEditDocumentSegmentStyles = styled(WSFormGrid)`
  &.cve-document-segment {
    .cve-empty-list-placeholder.cve-empty-list-placeholder {
      height: 160px;
    }
  }
`;
